import EventBus from './EventBus';

export default class HintProblemService {
    handleNewProblemsHeader(response) {
        if (!response.headers.hasOwnProperty('x-problems-available')) {
            return;
        }

        // The precise set of problems this request created (see FractalSubscriber/ProblemHandler), so the
        // overlay can fetch exactly these instead of an institution-wide "anything new in the last hour"
        // query that also surfaces unrelated problems created around the same time by anything else.
        const uuidsHeader = response.headers['x-new-problem-uuids'];
        let uuids = [];
        if (uuidsHeader) {
            try {
                uuids = JSON.parse(uuidsHeader);
            } catch {
                uuids = [];
            }
        }

        EventBus.$emit('hint:problem-created', uuids);
    }
}
